export var SET_SCAN_MODE = 'SET_SCAN_MODE';
export var setMode = function (mode) { return function (dispatch) {
    return dispatch({
        type: SET_SCAN_MODE,
        data: mode,
    });
}; };
